import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Link } from "../Link";
import { Icon } from "../../components/Icons";
import { Row, Cell } from "../../components/Grid";
import * as sharedStyles from "./QuickLinks.module.scss";

const defaultQuickLinksClassNames = {
	btnContainer: sharedStyles.btnContainer,
	btn: sharedStyles.btn,
	btnIcon: sharedStyles.btnIcon,
};

const QuickLinks = ({ classNames: providedClassNames, links }) => {
	const qlClassNames = {
		...defaultQuickLinksClassNames,
		...providedClassNames,
	};
	return (
		links && (
			<Row cols="2">
				{links.map(link => (
					<Cell key={link.id}>
						<div className={cx(sharedStyles.btnContainer, qlClassNames.btnContainer)}>
							<Link
								to={link.to}
								className={cx(sharedStyles.btn, qlClassNames.btn, {
									[sharedStyles.btnAlt]: link.invertButtonStyle,
								})}
								title={link.text}
								data-scroll-id="true">
								<Icon
									name="anchor"
									className={cx(sharedStyles.btnIcon, qlClassNames.btnIcon)}
									title={link.text}
								/>
								{link.text}
							</Link>
						</div>
					</Cell>
				))}
			</Row>
		)
	);
};

QuickLinks.propTypes = {
	classNames: PropTypes.shape({
		btn: PropTypes.string,
		btnIcon: PropTypes.string,
	}),
	links: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
			to: PropTypes.string.isRequired,
			invertButtonStyle: PropTypes.bool,
		})
	),
};

QuickLinks.defaultProps = {
	classNames: {},
	links: null,
};

export default QuickLinks;
export { QuickLinks };
